import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';

declare var google: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'MAPS';
  page: any;
  clientId = '750784711285-rhffc8uejm9bqscm9hikns8rb9qok493.apps.googleusercontent.com';

  constructor(
    private activatedRoute: ActivatedRoute,
    private route: Router,
    private ngZone: NgZone
  ) {
    this.route.events.subscribe((data) => {
      if (data instanceof RoutesRecognized) {
        this.page = data.state.root.firstChild.data.page;
      }
    });
    
  }
  ngOnInit(): void {

  }
}



